<div *ngIf="updateNeeded" class="alert alert-info my-0 py-1 px-3" role="alert">
  {{'notif.update_needed'|translate}}
  <button class="btn btn-primary ml-2 py-0" (click)="update()" >
    {{'common.reload'|translate|uppercase}}
  </button>
</div>